module.exports = __webpack_public_path__ + "img/Kultapossu-I.d6a15b04.png";